import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { api } from "../utilities/redux-api/api";
import { vendor_category_api } from "../utilities/redux-api/vendor_category/api";
import { sap_api } from "../utilities/redux-api/sap/sap_api";
import { admin_vendor_api } from "../utilities/redux-api/vendor/EditedVendorWorkflow";

export default configureStore({
  reducer: rootReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "GSTdocument/GSTDOCUMENT/pending",
          "GSTdocument/GSTDOCUMENT/fulfilled",
          "GSTdocument/GSTDOCUMENT/rejected",
          "vendorRegistration/VENDORREGISTRATION/pending",
          "vendorRegistration/VENDORREGISTRATION/fulfilled",
          "vendorRegistration/VENDORREGISTRATION/rejected",
          "vendorRegistrationUpdate/VENDORREGISTRATIONUPDATE/pending",
          "vendorRegistrationUpdate/VENDORREGISTRATIONUPDATE/fulfilled",
          "vendorRegistrationUpdate/VENDORREGISTRATIONUPDATE/rejected",
          "vendorRegistrationUpdateDocuments/VENDORREGISTRATIONUPDATEDOCUMENTS/pending",
          "vendorRegistrationUpdateDocuments/VENDORREGISTRATIONUPDATEDOCUMENTS/fulfilled",
          "vendorRegistrationUpdateDocuments/VENDORREGISTRATIONUPDATEDOCUMENTS/rejected",
          "bussinesslocations/BUSINESSLOCATIONS/pending",
          "bussinesslocations/BUSINESSLOCATIONS/fulfilled",
          "bussinesslocations/BUSINESSLOCATIONS/rejected",
          "bussinesslocationsupdate/BUSINESSLOCATIONSUPDATE/pending",
          "bussinesslocationsupdate/BUSINESSLOCATIONSUPDATE/fulfilled",
          "bussinesslocationsupdate/BUSINESSLOCATIONSUPDATE/rejected",
          "addbankdetails/ADDBANKDETAILS/pending",
          "addbankdetails/ADDBANKDETAILS/fulfilled",
          "addbankdetails/ADDBANKDETAILS/rejected",
          "editBanks/EDITBANKS/pending",
          "editBanks/EDITBANKS/fulfilled",
          "editBanks/EDITBANKS/rejected",
          "createInvoice/CREATEINVOICE/pending",
          "createInvoice/CREATEINVOICE/fulfilled",
          "createInvoice/CREATEINVOICE/rejected",
          "createSchedule/CREATESCHEDULE/pending",
          "createSchedule/CREATESCHEDULE/fulfilled",
          "createSchedule/CREATESCHEDULE/rejected",
          "createInspection/CREATEINSPECTION/pending",
          "createInspection/CREATEINSPECTION/fulfilled",
          "createInspection/CREATEINSPECTION/rejected",
          "createLot/CREATELOT/pending",
          "createLot/CREATELOT/fulfilled",
          "createLot/CREATELOT/rejected",
          "item_upload_excel/ITEMUPLOADEXCEL/pending",
          "item_upload_excel/ITEMUPLOADEXCEL/fulfilled",
          "item_upload_excel/ITEMUPLOADEXCEL/rejected",
          "documentRequests/UPLOAD_DOC/pending",
          "documentRequests/UPLOAD_DOC/fulfilled",
          "documentRequests/UPLOAD_DOC/rejected",
          "reg_vendor/REG_VENDOR/pending",
          "reg_vendor/REG_VENDOR/fulfilled",
          "reg_vendor/REG_VENDOR/rejected",
          "createPr/CREATEPR/pending",
          "createPr/CREATEPR/fulfilled",
          "createPr/CREATEPR/rejected",
          "excelToPrItemDetails/EXCELTOPRITEMDETAILS/pending",
          "excelToPrItemDetails/EXCELTOPRITEMDETAILS/fulfilled",
          "excelToPrItemDetails/EXCELTOPRITEMDETAILS/rejected",
          "editPr/EDITPR/pending",
          "editPr/EDITPR/fulfilled",
          "editPr/EDITPR/rejected",
          "createOrder/CREATEORDER/pending",
          "createOrder/CREATEORDER/fulfilled",
          "createOrder/CREATEORDER/rejected",
          "createLedger/CREATELEDGER/pending",
          "createLedger/CREATELEDGER/fulfilled",
          "createLedger/CREATELEDGER/rejected",
          "createGrn/CREATEGRN/pending",
          "createGrn/CREATEGRN/fulfilled",
          "createGrn/CREATEGRN/rejected",
          "createArn/CREATEARNS/pending",
          "createArn/CREATEARNS/fulfilled",
          "createArn/CREATEARNS/rejected",
          "createAsn/CREATEASN/pending",
          "createAsn/CREATEASN/fulfilled",
          "createAsn/CREATEASN/rejected",
        ],
        ignoredPaths: ["vendorRegistration.filePayload"],
      },
    })
      .concat(api.middleware)
      .concat(vendor_category_api.middleware)
      .concat(sap_api.middleware)
      .concat(admin_vendor_api.middleware),
});
